import React from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { PrivateRoute, NotFound, PublicRoute } from '@gsa/afp-shared-ui-utils';
import VehicleStandardsPage from './landing-page';
import DocPreview from './doc-preview';
import FvsProvider from './fvs-provider';
import FvsSupportingDocsProvider from './fvs-supporting-docs-provider';
import CommentingPeriods from './commenting-periods';
import Requirements from './requirements';
import FvsPreBidProvider from './fvs-pre-bid-selection-provider';
import PreBidSelectionsPage from './pre-bid-selection';
import FvsCommentsProvider from './fvs-comments-provider';
import PreBidSummaryPage from './pre-bid-summary';
import PreBidReportPage from './pre-bid-report';
import { OPERATIONS, SUBJECTS } from '../../utilities/constants';

const FedVehicleStandards = () => {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <FvsProvider>
      <FvsSupportingDocsProvider>
        <FvsPreBidProvider>
          <FvsCommentsProvider>
            <Routes>
              <Route
                path="/"
                element={
                  <PrivateRoute
                    title="Federal Vehicle Standards"
                    contextLocation={location}
                  >
                    <VehicleStandardsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pre-bid-selections/:year"
                element={
                  <PrivateRoute
                    title="Pre-bid Selections"
                    contextLocation={location}
                  >
                    <PreBidSelectionsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pre-bid-report/:year"
                element={
                  <PrivateRoute
                    title="Pre-bid Report"
                    contextLocation={location}
                    operation={OPERATIONS.View}
                    subject={SUBJECTS.PreBidReport}
                  >
                    <PreBidReportPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/requirements"
                element={
                  <PrivateRoute
                    title="Vehicle Requirements"
                    contextLocation={location}
                    contextNavigation={navigate}
                  >
                    <Requirements />
                  </PrivateRoute>
                }
              />
              <Route
                path="/preview/:year/:fvsId/:docId?"
                element={
                  <PrivateRoute
                    title="Vehicle Standards Documentation"
                    contextLocation={location}
                  >
                    <DocPreview />
                  </PrivateRoute>
                }
              />
              <Route
                path="/commenting-periods"
                element={
                  <PrivateRoute
                    title="Commenting Periods"
                    contextLocation={location}
                  >
                    <CommentingPeriods />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pre-bid-summary/:year"
                element={
                  <PrivateRoute
                    contextLocation={location}
                    contextNavigation={navigate}
                    title="Pre-bid Summary"
                    operation={OPERATIONS.Create}
                    subject={SUBJECTS.PSOQuestionnaire}
                  >
                    <PreBidSummaryPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/:year/:fedCode"
                element={
                  <PrivateRoute
                    title="Federal Vehicle Standards"
                    contextLocation={location}
                  >
                    <VehicleStandardsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="*"
                element={
                  <PublicRoute title="Sorry for the Detour">
                    <NotFound />
                  </PublicRoute>
                }
              />
            </Routes>
          </FvsCommentsProvider>
        </FvsPreBidProvider>
      </FvsSupportingDocsProvider>
    </FvsProvider>
  );
};

export default FedVehicleStandards;
